import Button, { ButtonProps } from "shared/Button/Button";
import React from "react";

export interface ButtonPrimaryProps extends ButtonProps {}

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  buttonId,
  className = "",
  ...args
}) => {
  return (
    <Button
      buttonId={buttonId}
      className={`ttnc-ButtonPrimary disabled:bg-opacity-70 bg-primary-6000 hover:bg-primary-700 text-neutral-50  hover:text-neutral-10 ${className}`}
      {...args}
    />
  );
};

export default ButtonPrimary;
